import { BACKEND_URL } from "@/api/client";

/** Same default food photo used in the owner dashboard product list. */
export function defaultProductImageUrl(width = 800) {
  return `https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&w=${width}&q=80`;
}

function resolveMediaPath(url) {
  const raw = String(url || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  return `${BACKEND_URL || ""}${raw}`;
}

function normalizeImageList(images) {
  if (Array.isArray(images)) return images;
  if (typeof images === "string" && images.trim()) return [images];
  return [];
}

/** First product image, or the default Unsplash placeholder when missing. */
export function resolveProductImageUrl(images, { width = 800 } = {}) {
  const first = normalizeImageList(images)
    .map((item) => resolveMediaPath(item))
    .find(Boolean);
  return first || defaultProductImageUrl(width);
}
